import * as React from "react"
import * as ReactDOM from "react-dom"
import Config from "../../Constants/index";
import { getIdToken } from "firebase/auth";
import Select from 'react-select';
import Axios from 'axios';

const IsoStandardLkp = (props) => {

    const [data, setData] = React.useState([]);
    const [selectedOption, setSelectedOption] = React.useState(props.defaultValue);

    React.useEffect(() => {
         setSelectedOption(props.defaultValue);
    }, [props.defaultValue]);

    React.useEffect(() => {  
            fetchData();
    }, []);

    const fetchData = () => {

        getIdToken(props.user).then((idToken) => {

            Axios.get(Config.API_URL + "IsoStandard/GetIsoStandardListAdmin/?Skip=" + 0
                + "&Take=" + 5
                + "&SortField=" + ""
                + "&SortDir=" + ""
                + "&timestamp=" + new Date().getTime(),
                {
                    headers: {
                        'Authorization': 'Bearer ' + idToken
                    }
                }
            ).then(response => {

                var list = response.data.rowModels.map(item => {
                    return {
                        value: item.id,
                        label: item.title 
                    }
                });

                setData(list)



            }).catch(error => {
                console.log(error);
            })
        });

    }


    const selectedOptionHandler = (selectedValue) => {
        setSelectedOption(selectedValue)
        props.onChange(selectedValue);
    }

    return (
            <Select className="form-control"
                value={selectedOption}    
                onChange={selectedOptionHandler}
                options={data}
                controlShouldRenderValue={true}
            />
    )
}

export default IsoStandardLkp;

